import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { PlanModel } from "@shared/models/plan.model";
import { PaginatedResponse, QueryParams } from "@shared/models/query-params.model";
import { BaseHttpService } from "@shared/services/base-http.service";

export interface PlanUpdatePayload {
  id: string;
  name?: string;
  aiRequestsLimit?: number | null;
  documentLimit?: number | null;
  shareLimit?: number | null;
}

export interface PlanCreatePayload extends PlanUpdatePayload {
  name: string;
}

@Injectable({
  providedIn: "root"
})
export class PlanHttpService extends BaseHttpService {
  protected override baseEndpoint = "";

  create(data: PlanCreatePayload): Observable<PlanModel> {
    return this.post<PlanModel>({
      endpoint: "admin/plans",
      body: data,
      type: PlanModel
    });
  }

  getAllPublic(params?: QueryParams): Observable<PaginatedResponse<PlanModel>> {
    return this.getMany<PlanModel>({
      endpoint: "plans/public",
      queryParams: params,
      type: PlanModel
    });
  }

  update(data: PlanUpdatePayload): Observable<PlanModel> {
    return this.patch<PlanModel>({
      endpoint: `admin/plans/${data.id}`,
      body: data,
      type: PlanModel
    });
  }

  deletePlan(id: string): Observable<void> {
    return this.delete<void>({
      endpoint: `admin/plans/${id}`
    });
  }

  getAll(params?: QueryParams): Observable<PaginatedResponse<PlanModel>> {
    return this.getMany<PlanModel>({
      endpoint: "admin/plans",
      queryParams: params,
      type: PlanModel
    });
  }

  getStripePrice(priceId: string): Observable<{ price: number }> {
    return this.get<{ price: number }>({
      endpoint: `admin/plans/stripe-price/${priceId}`
    });
  }
}
